import { ErrorBoundary } from '@worklogix/web-common';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { KioskApp } from './KioskApp';
import { registerServiceWorker } from './sync/registerServiceWorker';
import './kiosk.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Root element #root not found in index.html.');
}

/**
 * Composition root for the WorkLogix device clock (kiosk PWA). Providers wrap the
 * app from the outside in:
 *   ErrorBoundary (catches render failures anywhere below)
 *     → BrowserRouter (client-side routing shell / SPA-friendly)
 *       → KioskApp (device-token gate → pairing or live clock).
 *
 * DELIBERATELY ABSENT: MSAL AuthProvider / Entra. This is a device+PIN app; it
 * authenticates with a paired device token (x-worklogix-device header) and never
 * talks to Entra.
 */
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <KioskApp />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);

// Best-effort PWA install/offline support; never blocks the app.
registerServiceWorker();
